import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { api, API } from "@/lib/api";
import { ShareBar } from "@/components/ShareBar";
import { Avatar } from "@/components/Avatar";

export default function FeedPublic() {
  const { token } = useParams();
  const [post, setPost] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get(`/feed/public/${token}`)
      .then(({ data }) => setPost(data))
      .catch(() => setError("That post is not shared publicly."));
  }, [token]);

  if (error) return <div data-testid="public-post-error" className="p-10 text-center text-sm text-slate-500">{error}</div>;
  if (!post) return <div className="p-10 text-center text-sm text-slate-500">Loading…</div>;

  return (
    <div data-testid="public-post-page" className="mx-auto max-w-2xl p-5 sm:p-10">
      <p className="overline text-slate-500">Unity &amp; Utility</p>
      <div className="mt-1 flex items-center gap-2.5">
        <Avatar imageId={post.author_avatar_id} sig={post.author_avatar_sig} name={post.author_name} size="md" testid="public-post-avatar" />
        <h1 className="text-2xl font-semibold text-[#0F172A] sm:text-3xl">{post.author_name}</h1>
      </div>
      {post.caption && <p className="mt-3 text-sm text-slate-700" data-testid="public-post-caption">{post.caption}</p>}
      <div className="mt-4 space-y-3">
        {(post.media || []).map((m) => (m.kind === "video" ? (
          <video key={m.id} controls preload="metadata" data-testid={`public-video-${m.id}`} className="w-full border border-border bg-black" src={`${API}/feed/media/${m.id}`} />
        ) : (
          <img key={m.id} alt={post.caption || "post"} data-testid={`public-image-${m.id}`} className="w-full border border-border" src={`${API}/feed/media/${m.id}`} />
        )))}
      </div>
      {(post.comments || []).length > 0 && (
        <div className="mt-6 space-y-1.5 border-t border-border pt-4">
          {post.comments.map((c, i) => (
            <p key={i} className="text-xs text-slate-600"><span className="font-semibold text-[#0F172A]">{c.author_name}</span> {c.body}</p>
          ))}
        </div>
      )}
      <div className="mt-8 border-t border-border pt-5">
        <p className="text-xs text-slate-500">Share this post</p>
        <div className="mt-2">
          <ShareBar url={`${API.replace(/\/api$/, "")}/api/share/p/${token}`} text={post.caption || "Live from the yard"} testid="public-post-share" />
        </div>
        <Link to="/feed" data-testid="public-post-wall-link" className="mt-4 inline-block text-sm font-semibold text-[#002FA7] hover:underline">
          See everything happening at Unity &amp; Utility
        </Link>
      </div>
    </div>
  );
}
